import { render, staticRenderFns } from "./ConfigRecover.vue?vue&type=template&id=0727c6bd&scoped=true&"
import script from "./ConfigRecover.vue?vue&type=script&lang=js&"
export * from "./ConfigRecover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0727c6bd",
  null
  
)

export default component.exports